import src from "IMAGE";
export default { src, width: 104, height: 104, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
